const Page = ({children, ...rest}) => (
    <div
        className="bg-gradient-to-tl to-white from-primary flex flex-col justify-start items-center min-h-screen"
        {...rest}>
        {children}
    </div>
);

export default Page;